/* eslint-disable @typescript-eslint/no-explicit-any */
import { container } from 'tsyringe';

import { ToastStatus, ToastStore } from '../stores/toast';

/**
 * @category Utils
 * Decorator function for Toast messages
 */
function _generateDescriptor(descriptor: PropertyDescriptor, label: string): PropertyDescriptor {
  // Save a reference to the original method
  const originalMethod = descriptor.value;
  // Rewrite original method with try/catch wrapper
  descriptor.value = function (...args: any[]) {
    const toastStore = container.resolve(ToastStore);
    if (!toastStore || toastStore?.list === undefined) return;
    // eslint-disable-next-line no-useless-catch
    try {
      const result = originalMethod.apply(this, args);

      // Check if method is asynchronous
      if (result && result instanceof Promise) {
        // Return promise
        return result
          .then((result) => {
            toastStore.addToast(label, ToastStatus.success);
            return result;
          })
          .catch((error: any) => {
            toastStore.addToast(label, ToastStatus.fail);
            throw error;
          });
      }

      // Return actual result
      toastStore.addToast(label, ToastStatus.success);
      return result;
    } catch (error) {
      toastStore.addToast(label, ToastStatus.fail);
      throw error;
    }
  };
  return descriptor;
}

export const toast = (label: string): any => {
  return (target: any, propertyKey: string, descriptor: PropertyDescriptor) => {
    return _generateDescriptor(descriptor, label);
  };
};
